// extracted by mini-css-extract-plugin
module.exports = {"layout":"_1410bfd27b--layout--lLnS4"};